export const TEXT_OPEN_WITH_HEIGHT = 'Подробнее';
export const TEXT_HIDE_WITH_HEIGHT = 'Скрыть';
export const TEXT_OPEN_ITEMS = 'Больше';
export const TEXT_HIDE_ITEMS = 'меньше';
